/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileBoxNote32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlGray20}
                fillRule="nonzero"
                d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                fillRule="nonzero"
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill="#9725DD"
                d="M18.526 14.146l-.92 1.375h-6.92a.685.685 0 01-.686-.688c0-.38.31-.687.687-.687h7.839z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M16.379 17.583l-.92 1.375h-4.762a.69.69 0 01-.697-.687c0-.38.31-.688.697-.688h5.682z"
            />
            <path
                fill="#00C8C0"
                d="M14.231 21.02l-.424.637a2.166 2.166 0 00-.229.493l-.031.118-.028.127H10.69a.687.687 0 110-1.374h3.541z"
            />
            <path
                fill={vars.black}
                d="M14.841 21.332l4.64-6.72.053.092c.074.114.235.322.538.541.456.329.797.374.797.374l-4.64 6.72a2.558 2.558 0 01-.461.483l-1.373 1.037c-.146.11-.234.054-.193-.14l.372-1.764c.04-.187.156-.46.267-.623zm6.648-8.163c.373.272.407.704.407.704a3.57 3.57 0 01-.314.607l-.28.417-.09-.016a1.714 1.714 0 01-.632-.282c-.35-.255-.628-.687-.628-.687l.28-.418c.106-.158.284-.397.448-.51l.074-.009c.14-.012.456-.01.735.194z"
            />
        </g>
    </AccessibleSVG>
);

export default FileBoxNote32;
